import { render, staticRenderFns } from "./NewProjectsItem.vue?vue&type=template&id=50a55254&scoped=true&"
import script from "./NewProjectsItem.vue?vue&type=script&lang=js&"
export * from "./NewProjectsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a55254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
